import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VisaStatusService {
  private apiUrl = `${environment.apiUrl}/visaStatus`; // API URL'yi güncelliyoruz

  constructor(private http: HttpClient) {}

  // GET: Tüm Visa Status verilerini al
  getAll(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  // GET: Visa Status ID'ye göre veriyi al
  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

}
